// reducers/alertReducer.js

export const initialAlertState = {
    show: false,
    content: null,
    actionType: ''


};

export const alertReducer = (state = initialAlertState, action) => {
    switch (action.type) {
        case "ALERT_MODAL_TOGGLE":
            return {
                ...state,
                show: typeof action.payload?.show === "boolean" ? action.payload.show : state.show,
                content: action.payload?.content ?? state.content,
                actionType: typeof action.payload?.actionType === "string" ? action.payload : state.actionType?.actionType,
            };
        default:
            return state;
    }
};
